<template>
  <div class="home">
    <headers class="wow fadeInDown"></headers>
    <bdMap></bdMap>
    <div class="homemain">
      <div class="homemainl">
        <div ref="elementLeft" @click="hide1=false" :style="'margin-left: -'+ left1 +'px'" class="item1 transition wow fadeInLeft">
          <item>
            <item1 @getHide="getHide1" @changeid="gettcdata" @checkdata="checkdata" title="监测点浏览"></item1>
          </item>
        </div>
        <div @click="hide2=false" :class="{leftHide:hide2}" :style="'margin-left: -'+ left2 +'px'" class="item2 transition wow fadeInLeft"
             data-wow-delay="0.5s">
          <item>
            <item2 @getHide="getHide2" :depid="depid" title="异常统计"></item2>
          </item>
        </div>
        <div @click="hide3=false" :class="{leftHide:hide3}" :style="'margin-left: -'+ left3 +'px'" class="item3 transition wow fadeInLeft" data-wow-delay="1s">
          <item>
            <item7 @getHide="getHide7" title="隐患推送"></item7>
<!--            <item3 @getHide="getHide3" title="能耗占比"></item3>-->
          </item>
        </div>
      </div>

      <div class="homemainr">

        <div  class="homemainrTopTj wow fadeInDown" data-wow-delay="0.5s">
          <item9 v-show="cqyjShow" @opencqyj="opencqyj" :depid="depid"></item9>
          <div class="listTopTj">
            <div class="itemsTopTj" v-for="(item , index) in titledata">
              <span @click="opentc(index)">{{ item.riskLevelType }}<span  >{{ item.totalCount }}</span></span>
              <div class="yjtx2" v-show="showtc[index]">
                <div class="page1" >
                  <p @click="selectTc(group)" v-for="group in item.alertLevelRiskCounts"><em>{{ group.alertLevelName }}</em> <span>{{ group.count }}</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div  class="homemainrTop wow fadeInDown" data-wow-delay="0.5s">
        </div>
        <div class="homemainrBottom">


          <div ref="elementBottom" @click="hide4=false" :style="'margin-bottom: -'+ bottom1 +'px'"
               class="item4 wow fadeInUp transition"
               data-wow-delay="1s">
            <item>
              <item5 @getHide="getHide4" title="隐患统计"></item5>
            </item>
          </div>
          <div @click="hide5=false" :style="'margin-bottom: -'+ bottom2 +'px'" class="item5 wow fadeInRight transition"
               data-wow-delay="1s">
            <item>
              <item8 @getHide="getHide5" title="能耗统计"></item8>
            </item>
          </div>
        </div>
      </div>

    </div>

    <div class="power-blank" v-if="showblank">
      <item66></item66>
    </div>
    <div class="risk-blank" v-show="showrisk">
      <item88></item88>
    </div>
    <div class="list-blank" v-show="showtitle">
      <item77 :depid="depid" :alertLevel="alertLevel"></item77>
    </div>
    <audio controls ref="audioo" class="aud" style="display: none" >

      <source src="../assets/bj.mp3" />

    </audio>
<!--    <div class="zztc" v-show="showzz">-->

      <source src="../assets/bj.mp3" />

    </audio>
<!--    <button class="butt"  @click="bofang1">确认</button>-->
  </div>
</template>

<script>
import headers from "@/components/headers";
import item from '@/components/item/item'
import item1 from '@/components/home/item1'
import item2 from '@/components/home/item2'
import item3 from '@/components/home/item3'
import item4 from '@/components/home/item4'
import item5 from '@/components/home/item5'
import item6 from '@/components/home/item6'
import item7 from '@/components/home/item6'
import item8 from '@/components/home/item8'
import item9 from '@/components/home/item9'
import item66 from '@/components/home/item66'
import item77 from '@/components/home/item77'
import item88 from '@/components/home/item88'
import bdMap from "@/components/home/item4/components/map";
import Axios from "@/utils/Axios";
import Bus from "@/utils/bus.js";
export default {
  data() {
    return {
      list: [],
      hide1: false,
      hide2: false,
      showtitle: false,
      showrisk: false,
      hide3: false,
      hide4: false,
      hide5: false,
      hide7: false,
      showblank: false,
      showzz: false,

      titledata:[
        {
          "code": 1,
          "riskLevelType": "超前预警",
          "totalCount": 0,
          "alertLevelRiskCounts": [
            {
              "alertLevel": 2,
              "alertLevelName": "早期隐患",
              "simpleMess": "早期隐患",
              "riskLevel": 2,
              "count": 0
            },
            {
              "alertLevel": 3,
              "alertLevelName": "中期隐患",
              "simpleMess": "中期隐患",
              "riskLevel": 3,
              "count": 0
            },
            {
              "alertLevel": 4,
              "alertLevelName": "运行危险",
              "simpleMess": "运行危险",
              "riskLevel": 5,
              "count": 0
            },
            {
              "alertLevel": 102,
              "alertLevelName": "接触电阻过大",
              "simpleMess": "接触电阻过大",
              "riskLevel": 5,
              "count": 0
            }
          ]
        },
        {
          "code": 2,
          "riskLevelType": "老化监测",
          "totalCount": 0,
          "alertLevelRiskCounts": [
            {
              "alertLevel": 95,
              "alertLevelName": "设备触电隐患",
              "simpleMess": "设备触电隐患",
              "riskLevel": 3,
              "count": 0
            },
            {
              "alertLevel": 96,
              "alertLevelName": "设备严重隐患",
              "simpleMess": "设备严重隐患",
              "riskLevel": 4,
              "count": 0
            },
            {
              "alertLevel": 101,
              "alertLevelName": "线路老化",
              "simpleMess": "线路老化",
              "riskLevel": 3,
              "count": 0
            },
            {
              "alertLevel": 105,
              "alertLevelName": "零线绝缘破损",
              "simpleMess": "零线绝缘破损",
              "riskLevel": 2,
              "count": 0
            }
          ]
        },
        {
          "code": 3,
          "riskLevelType": "误报源识别",
          "totalCount": 6,
          "alertLevelRiskCounts": [
            {
              "alertLevel": 97,
              "alertLevelName": "劣质用电设备",
              "simpleMess": "劣质用电设备",
              "riskLevel": 6,
              "count": 0
            },
            {
              "alertLevel": 99,
              "alertLevelName": "零地混接",
              "simpleMess": "零地混接",
              "riskLevel": 6,
              "count": 0
            },
            {
              "alertLevel": 100,
              "alertLevelName": "接线不规范",
              "simpleMess": "接线不规范",
              "riskLevel": 6,
              "count": 6
            }
          ]
        },
        {
          "code": 4,
          "riskLevelType": "短路识别",
          "totalCount": 1,
          "alertLevelRiskCounts": [
            {
              "alertLevel": 103,
              "alertLevelName": "早期短路",
              "simpleMess": "早期短路",
              "riskLevel": 3,
              "count": 1
            },
            {
              "alertLevel": 104,
              "alertLevelName": "严重短路",
              "simpleMess": "严重短路",
              "riskLevel": 5,
              "count": 0
            }
          ]
        },
        {
          "code": 5,
          "riskLevelType": "其他",
          "totalCount": 230,
          "alertLevelRiskCounts": [
            {
              "alertLevel": 0,
              "alertLevelName": "设备新装",
              "simpleMess": "设备新装",
              "riskLevel": 1,
              "count": 83
            },
            {
              "alertLevel": 1,
              "alertLevelName": "运行正常",
              "simpleMess": "运行正常",
              "riskLevel": 1,
              "count": 147
            }
          ]
        }
      ],
      alertLevel:"",
      pointerEvents: 'initial',
      active: false,
      cqyjShow: false,
      depid:2,
      showtc:[false,false,false,false,false],
    }
  },
  components: {headers, item, item1, item2, item3, item4, item5, item6, item7, item8, bdMap, item9,item66,item77,item88},
  created() {

  },
  mounted() {
    new this.$wow.WOW().init()
    this.depid= Number(localStorage.getItem("deptId"));
    this.getdaypowdata()
    this.initWebSocket()
    this.hide7 = true;
    Bus.$on("colsetc", (val) => {
      this.showzz=val
      this.showtitle=false
      this.showblank=false
      this.showrisk=false
    })
    Bus.$on("opentc", (val) => {
      this.showtitle=false
      this.showblank=false
      this.showrisk=false
    if(val=='power'){
      this.showblank=true
    }else if(val=='risk'){
      this.showrisk=true
    } else{
      this.showtitle=true
    }


    })
    Bus.$on("changeid", (val) => {

      this.depid=val.deptId
      this.getdaypowdata()

    })
  },
  computed: {
    bottom1: function () {
      var bottom = 0
      if (this.hide4) {
        bottom = this.$refs.elementBottom.offsetHeight*2
      } else {
        bottom = 0
      }
      return bottom
    },
    right1: function () {
      var right = 0
      if (this.hide7) {
        right = this.$refs.elementRight.offsetWidth
      } else {
        right = 0
      }
      return right
    },
    bottom2: function () {
      var bottom = 0
      if (this.hide5) {
        bottom = this.$refs.elementBottom.offsetHeight*2
      } else {
        bottom = 0
      }
      return bottom
    },
    left1: function () {
      var left = 0
      if (this.hide1) {
        left = this.$refs.elementLeft.offsetWidth*2
      } else {
        left = 0
      }
      return left
    },
    left2: function () {
      var left = 0
      if (this.hide2) {
        left = this.$refs.elementLeft.offsetWidth*2
      } else {
        left = 0
      }
      return left
    },
    left3: function () {
      var left = 0
      if (this.hide3) {
        left = this.$refs.elementLeft.offsetWidth*2
      } else {
        left = 0
      }
      return left
    }
  },
  methods: {
    bofang1(){
      let music1 = new Audio(); //建立一个music1对象

      music1 = require("../assets/bj.mp3");//通过require引入音频

      this.$refs.audio.src = music1;//此处的audio为代码ref="audio"中的audio

      this.$refs.audio.play();//play()为播放函数

    },
    selectTc(item){
    this.alertLevel=item.alertLevel
      this.showtitle=true
    this.showzz=true
      this.showtc=[false,false,false,false,false]
    },
    closeTc(){

    },
    // 初始化一个 websocket 对象，同时给基本属性赋值
    initWebSocket: function () {
      var token = sessionStorage.getItem("token");

      // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https，此处传入需要跟后台连接的接口路径
      //this.websock = new WebSocket( "ws://124.70.202.197/websocket/event?authorization=" + token); //正式服
      this.websock = new WebSocket("wss://www.wha518.com/websocket/event?authorization="+ token);//测试服
      //
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },
    // 定义 websocket open属性的函数
    websocketonopen: function () {
      // this.websock.send(token)
      console.log("WebSocket连接成功");
    },
    // 定义 websocket onerror属性的函数
    websocketonerror: function (e) {
      console.log("WebSocket连接发生错误");
    },
    // 定义 websocket onmessage属性的函数
    websocketonmessage: function (e) {
      let that = this;
      let mess = e.data;
      let messsdata = JSON.parse(mess);
      if(this.$route.path!='/newlogin'){
        that.bofang1()
        // that.$notify({
        //   title: "测点名称" + messsdata.monitorName,
        //   message:
        //     "故障名称:" +
        //     messsdata.eventName +
        //     ";发生时间:" +
        //     that.formatDateTime(messsdata.eventTime),
        //   // message: '故障名称:'+ messsdata.event_name + '</br>发生时间'+ ,
        //   position: "bottom-right",
        //   type: "warning",
        //   onClick: function () {
        //     // that.addrouter('历史事件','/thingPage/historyPage')
        //   },
        // });

      }

      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
    },
    // 定义 websocket onclose属性的函数
    websocketclose: function (e) {
      console.log("connection closed");
    },
    gettcdata(val){
        console.log(val)

    },
    opentc(val){

      for(let i=0;i<this.showtc.length;i++){
        if(val==i){
          this.showtc[i]=!this.showtc[i]
        }else{
          this.showtc[i]=false
        }

      }

      this.$forceUpdate();
    },
    checkdata(val){

      this.cqyjShow=true
    },
    getHide1() {
      this.hide1 = true
    },
    getHide2() {
      this.hide2 = true
    },
    getHide3() {
      this.hide3 = true
    },
    getHide4() {
      this.hide4 = true
    },
    getHide5() {
      this.hide5 = true
    },
    getHide7() {
      this.hide7 = true
    },
    getdaypowdata(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/portal/riskTypeCount"

      param.data={
        deptId:this.depid
      }

      Axios.ajax(param).then((res)=>{
        if(res.resultCode=='0'){

          this.titledata=res.data


        }else{

        }

      })
    },
    opencqyj () {
      this.cqyjShow = this.cqyjShow == false ? true : false
    }
  },
  filters: {},
  watch: {
    depid(){

    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  position: fixed;
  height: 100%;

  overflow: auto;
  background: url("../assets/home/bg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: column;
}
.butt{
  z-index: 1000;
  width: 100px;
  background-color: red;
}
.power-blank{
  width: 807px;
  height: 820px;
  position: absolute;
  top: calc(50% - 376px);
  left: calc(50% - 403px);
  z-index: 2000;
}
.risk-blank{
  width: 807px;
  height: 600px;
  position: absolute;
  top: calc(50% - 300px);
  left: calc(50% - 403px);
  z-index: 2000;
}
.list-blank{
  width: 807px;
  height: 600px;
  position: absolute;
  top: calc(50% - 300px);
  left: calc(50% - 403px);
  z-index: 2000;
}
.zztc{
  background-color:#999;filter:Alpha(Opacity=60);opacity:0.6;
  width: 100%;
  height: 100%;
  z-index: 100;
  position: absolute;
  top: 0;
  left: 0;
}

.yjtx2 {
  background: url("../assets/home/item6_popbg1.png") no-repeat ;

  width: 184px;

  background-size: 100% 100%;
  position: absolute;
  left: -3px;
  top: 50px;
  display: flex;
  z-index: 10;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: column;

  .close {
    width: 17px;
    height: 17px;
    position: absolute;
    right: 5px;
  }
}
.page1 {
  margin-left: 20px;
  padding-top: 30px;
  width: 100%;
  p {
    font-size: 14px;
    font-family: PingFang;
    font-weight: 500;
    color: rgba(#ffffFF, 1);
    line-height: 28px;
    margin-bottom: 4px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    flex-direction: row;
    align-content: flex-start;
    em {
      font-style: normal;
      margin-right: 10px;
      width: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      align-content: flex-start;
    }

    span {
      font-size: 14px;
      font-family: PingFang;
      font-weight: 500;
      color: #CDF7FF;
    }
    .pageTitle {
      font-size: 18px;
      width: 25%;
    }
    .pageNr {
      font-size: 18px;
      width: 25%;
      a {
      }
    }
  }
}
.homemain {
  position: relative;
  width: calc(100% - 0px);
  height: calc(100% - 110px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  z-index: 10;
  pointer-events: none;

  .homemainl {
    width: calc(25% - 20px - 23px);
    margin-left: 20px;
    position: relative;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: column;
    align-content: flex-start;
    margin-left: 20px;
    margin-right: 23px;
    pointer-events: initial;

    .item1 {
      width: 100%;
      height: calc(38% - 20px);
      margin-bottom: 20px;
      position: relative;
    }

    .item2 {
      width: 100%;
      height: calc(31% - 20px);
      margin-bottom: 20px;
      position: relative;
    }

    .item3 {
      width: 150%;
      height: 31%;
      position: relative;
      left: 25%;
    }
  }

  .homemainr {
    width: calc(75% - 20px);
    position: relative;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: column;
    align-content: flex-start;
    z-index: 11;
    margin-right: 20px;

    .homemainrTopTj{
      width: 100%;
      height: 30%;
      display: flex;
      justify-content: space-between;
      flex-direction: row;

      .listTopTj {
        margin-left: 30px;
        display: flex;
        margin-top: 20px;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: center;
      }

      .itemsTopTj {
        background: url("../assets/home/dayTimebg.png") no-repeat;
        background-color: #041c75;
        background-size: 180px 38px;
        width: 180px;
        height: 38px;
        opacity: 0.9;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;
        align-content: flex-start;
        margin-right: 29px;
        cursor: pointer;
       // background-color: #2473c2;
        pointer-events: initial;
        position: relative;
        span {
          font-size: 18px;
          font-family: PingFang;
          font-weight: 500;
          color: #ffffff;
          span {
            margin-left: 20px;
            color: #ffbc00;
          }
        }

      }

      .itemsTopTj:hover {
        opacity: 1;
      }
    }

    .homemainrTop {
      width: 100%;
      height: 30%;
    /*  pointer-events: initial;*/
      display: flex;
      justify-content: space-between;
      flex-direction: row-reverse;
    }

    .homemainrBottom {
      width: 100%;
      height: 31%;
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      align-content: flex-start;
      pointer-events: initial;

      .item4 {
        width: calc(40% - 20px);
       /* margin-right: 20px;*/
        height: 100%;
        position: relative;
        left: 15%;
      }

      .item5 {
        width: 45%;
        height: 100%;

      }
    }
  }
}

//.footEc {
//  width: 100%;
//  height: 180px;
//  background: #03265a;
//  border: 1px solid #24539e;
//  border-radius: 20px;
//  position: absolute;
//  bottom: 0;
//  z-index: 12;
//}
.leftHide {
  margin-left: -200%;
}

.DownHide {
  margin-bottom: -70%;
}
</style>
<style>
.anchorBL{
  display: none;
}
.BMap_cpyCtrl{
  display: none;
}

#app .home .el-input.el-input__inner, #app .mapTc .el-input > .el-input__inner, #app .mapTc .el-date-editor.el-input__inner, #app .mapTc .el-date-editor > .el-input__inner
{
  background-color: rgba(61, 130, 234, 0.24);
  color: #6CBCFD;
  border: 1px solid #0B47A5;
}
#app .home .el-input__prefix, .el-input__suffix{
  color: #6CBCFD;

}
#app .home .el-table{
  background-color: rgba(0, 37, 88, 0.9);
}
#app .home .el-table td{
  background-color: rgba(0, 37, 88, 0.9);
  color: #6CBCFD;
  text-align: center;
}
#app .home .el-table tbody tr:hover>td {
  background-color:rgba(0, 37, 88, 0.9)!important
}
#app .home .el-table th{
  background-color: rgba(0, 20, 150, 0.9);
  color: #6CBCFD;
  border: none;
}
#app .home .el-table td, #app .mapTc .el-table th.is-leaf{
  border: none;
}
#app .home .el-pagination .el-pager li.active, #app .el-pagination .el-pager li:hover{
  color: #fff;
}
#app .home  .el-table::before{
  height: 0;
}
</style>
